var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "q-field",
          {
            staticClass: "q-pa-md col-4",
            attrs: {
              "error-label": "Recruiter code is required",
              error: _vm.validation.recruiterForm.RECRUITER_CODE.$error
            }
          },
          [
            _c("q-input", {
              attrs: {
                "float-label": "Recruiter Code",
                value: _vm.recruiterForm.RECRUITER_CODE,
                after: [
                  {
                    icon: "flag",
                    color: "red",
                    class: "exclamation-circle-icon",
                    condition:
                      _vm.validation.recruiterForm.RECRUITER_CODE.$invalid,
                    handler: function handler() {}
                  },
                  {
                    icon: "fa fa-check",
                    condition: !_vm.validation.recruiterForm.RECRUITER_CODE
                      .$invalid
                  }
                ],
                disable: !_vm.canEdit,
                required: ""
              },
              on: {
                blur: _vm.validation.recruiterForm.RECRUITER_CODE.$touch,
                keyup: function($event) {
                  $event.stopPropagation()
                  _vm.updateRecruiterForm({
                    field: "RECRUITER_CODE",
                    value: $event.target.value
                  })
                }
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }